import { render, staticRenderFns } from "./dataV6.vue?vue&type=template&id=ae5b7faa&scoped=true&"
import script from "./dataV6.vue?vue&type=script&lang=js&"
export * from "./dataV6.vue?vue&type=script&lang=js&"
import style0 from "./dataV6.vue?vue&type=style&index=0&id=ae5b7faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b7faa",
  null
  
)

export default component.exports